/* eslint-disable indent */
import React, { useId } from 'react';
import PropTypes from 'prop-types';

import { Container, Content, Nub } from './tooltip.css';

function Tooltip(props) {
	const {
		text,
		position = 'top',
		size,
		delay = false,
		children,
		background = 'blue-base',
		nowrap = false,
		showArrow = true,
		fontSize,
		disabled = false,
		style = {}
	} = props;

	const tooltipId = useId();

	// Point the trigger at the bubble so assistive tech reads the reason even
	// though the tooltip itself is revealed with CSS.
	const trigger = React.isValidElement(children)
		? React.cloneElement(children, {
			'aria-describedby': [children.props['aria-describedby'], tooltipId]
				.filter(Boolean)
				.join(' ')
		})
		: children;

	return disabled
		? children
		: (
			<Container position={position} style={style}>
			{showArrow && <Nub position={position} delay={delay} background={background}/>}
			<Content
				id={tooltipId}
				role="tooltip"
				position={position}
				size={size}
				fontSize={fontSize}
				delay={delay}
				background={background}
				nowrap={nowrap}
			>
				{text}
			</Content>

			{trigger}

		</Container>
	);
}

Tooltip.propTypes = {
	text: PropTypes.string.isRequired,
	position: PropTypes.string,
	size: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	fontSize: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	delay: PropTypes.bool,
	background: PropTypes.string,
	nowrap: PropTypes.bool,
	showArrow: PropTypes.bool,
	disabled: PropTypes.bool,
	style: PropTypes.object
};

export default Tooltip;
